const option = [
    { id: 2, name: 'เจ้าของร้าน' },
    { id: 3, name: 'ทีมงาน' }
]

export default {
    option: option
};